import assigneeColors from "./assigneeColors";
import * as fieldTypes from "./fieldTypes";
import * as filterTypes from "./filterTypes";
import * as modalTypes from "./modalTypes";
import * as priorityCodes from "./priorityCodes";
import * as sortTypes from "./sortTypes";
import * as sortOrderTypes from "./sortOrderTypes";
import * as statusCodes from "./statusCodes";
import { translate } from "@td/shared_utils";

export const MAX_PRESENTED_ASSIGNEES = 3;

export const SERVER_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss Z";

export const CONSULTATION_DATE_FORMAT = "DD-MMM-YYYY@h:mm A";

export const TASK_DATE_FORMAT = "DD-MMM-YYYY h:mm A";

export const DEFAULT_PAGE_SIZE = 50;

export const MASKED_VALUE = '****';

export const defaultQueryParams = {
  page: 1,
  perPage: DEFAULT_PAGE_SIZE,
};

export const defaultFilters = {
  [filterTypes.TYPES]: [],
  [filterTypes.CATEGORY]: null,
  [filterTypes.ASSIGNEES]: [],
  [filterTypes.MEMBERS]: [],
  [filterTypes.DUE_DATE]: [],
  [filterTypes.PRIORITIES]: [],
  [filterTypes.STATUSES]: [
    { value: statusCodes.NOT_STARTED },
    { value: statusCodes.IN_PROGRESS },
  ],
  [filterTypes.CONSULT_DATE]: [],
};

export const defaultSortingParams = {
  column: sortTypes.DUE_DATE,
  order: sortOrderTypes.ASC,
};

export const defaultTaskFormValues = {
  [fieldTypes.TASK_TYPE]: null,
  [fieldTypes.TASK_NAME]: "",
  [fieldTypes.URGENT]: false,
  [fieldTypes.CATEGORY]: null,
  [fieldTypes.ASSIGNEE]: null,
  [fieldTypes.STATUS]: {
    value: statusCodes.NOT_STARTED,
    label: translate(null, "care_team_tasks.statuses", statusCodes.NOT_STARTED.replace("TASKSTATUS_", "")),
  },
  [fieldTypes.DUE_DATE]: null,
  [fieldTypes.CONSULT_ID]: { value: null, label: "" },
  [fieldTypes.NOT_CONSULT_RELATED]: false,
  [fieldTypes.MEMBER]: { value: null, label: "" },
  [fieldTypes.GROUP]: "",
  [fieldTypes.PROVIDER]: "",
  [fieldTypes.CHECKLIST]: [],
  [fieldTypes.NOTES]: "",
};

export const defaultTaskNotesFormValue = {
  [fieldTypes.NOTES]: "",
};

export const unassignedOption = {
  value: -1,
  label: translate(null, "care_team_tasks.filters.fields.assigned_to", "unassigned"),
};

export {
  assigneeColors,
  fieldTypes,
  filterTypes,
  modalTypes,
  priorityCodes,
  sortTypes,
  sortOrderTypes,
  statusCodes,
};
